import script from "./LeftSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSideBar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__